export class Role {
  id: number;
  role_type_id: number;
  role_id: number;
  role_type_name: string;

  constructor(role_type: any) {
    if (role_type.id) this.role_type_id = role_type.id;
    if (role_type.name) this.role_type_name = role_type.name;
  }
}
